import { Add } from '@mui/icons-material'
import { Chip, IconButton, Stack, TextField } from '@mui/material'
import type { FC } from 'react'
import { useState } from 'react'
import type { ResponseSetCategoryForm } from './ResponseSetTypes'

type OwnProps = {
  tags: ResponseSetCategoryForm[]
  onInputConfirm: (tagName: string) => void
  onClose: (index: number) => void
}

const ResponseSetTags: FC<OwnProps> = props => {
  const [categoryInputVisible, setCategoryInputVisible] = useState(false)
  const [inputValue, setInputValue] = useState('')

  const onConfirm = () => {
    if (!inputValue) return
    props.onInputConfirm(inputValue)
    setCategoryInputVisible(false)
    setInputValue('')
  }

  return (
    <Stack direction="row" flexWrap="wrap" spacing={0.5}>
      {props.tags.map((tag, index) => (
        <Chip
          key={tag.key}
          label={tag.name}
          size="small"
          color="primary"
          variant="pale"
          onDelete={() => props.onClose(index)}
          sx={{ maxWidth: '100%', '& .MuiChip-label': { maxWidth: '25em' } }}
        />
      ))}
      {categoryInputVisible && (
        <TextField
          autoFocus
          size="small"
          value={inputValue}
          slotProps={{
            htmlInput: { 'aria-label': 'カテゴリー名', maxLength: 255 },
          }}
          onChange={e => setInputValue(e.target.value)}
          onBlur={onConfirm}
          onKeyDown={e => {
            if (e.key === 'Enter') onConfirm()
          }}
          sx={{ width: 78 }}
        />
      )}
      {!categoryInputVisible && (
        <IconButton
          size="small"
          onClick={() => setCategoryInputVisible(true)}
          sx={{
            border: '1px dashed',
            borderColor: 'divider',
            borderRadius: 1,
            p: 0.25,
          }}
        >
          <Add fontSize="small" />
        </IconButton>
      )}
    </Stack>
  )
}

export default ResponseSetTags
